import { ArrowRight } from "lucide-react";
import handleOpenApp from "../Utility/HandleOpenApp";
import Reveal from "../Plan2Benefit/Reveal.jsx";
import Magnetic from "./Magnetic.jsx";

/* ─────────────────────────────────────────────────────────────
   CTA — the page's one illustrated moment: the key handover.
   Every other section stays plain and numbers-led; this is the
   only place gold appears as an ILLUSTRATION (the key-handover
   icon and its ambient glow), so the close still reads as
   deliberate rather than decoration.

   Gold also now appears as a flat color accent on the "Get Your
   First EMI Free*" banner in Hero.jsx — that's a different use
   (a small tinted badge, not an illustrated moment), so it doesn't
   compete with this section for the "one illustrated moment" role.
───────────────────────────────────────────────────────────── */
export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-white px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[42rem] w-[64rem] -translate-x-1/2 -translate-y-1/2"
        style={{
          background:
            "radial-gradient(closest-side, rgba(216,172,103,0.16), rgba(216,172,103,0) 72%)",
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[30rem] w-[42rem] -translate-x-[65%] -translate-y-[55%]"
        style={{
          background:
            "radial-gradient(closest-side, rgba(67,40,231,0.10), rgba(67,40,231,0) 70%)",
        }}
      />

      <Reveal className="relative mx-auto max-w-xl text-center">
        <div className="inline-flex items-center gap-3">
          <span className="h-px w-8 bg-gradient-to-r from-transparent to-[#d8ac67]/50" />
          <span className="font-montserrat text-[10.5px] font-bold uppercase tracking-[0.3em] text-[#a3792e]">
            Ready when you are
          </span>
          <span className="h-px w-8 bg-gradient-to-l from-transparent to-[#d8ac67]/50" />
        </div>

        <h2 className="mt-6 font-montserrat text-[2.1rem] font-black leading-[1.05] tracking-[-0.03em] text-[#0d0828] sm:text-[2.9rem]">
          Ready to bring your car home?
        </h2>
        <p className="mt-4 font-montserrat text-[17px] font-semibold text-[#0d0828]/55 sm:text-lg">
          Create your Car Plan in minutes.
        </p>

        <svg
          aria-hidden="true"
          width="72"
          height="72"
          viewBox="0 0 96 96"
          fill="none"
          className="mx-auto mt-9"
        >
          <circle cx="30" cy="30" r="15" stroke="#d8ac67" strokeWidth="3.5" />
          <line x1="41" y1="41" x2="80" y2="80" stroke="#d8ac67" strokeWidth="3.5" strokeLinecap="round" />
          <line x1="66" y1="66" x2="76" y2="56" stroke="#d8ac67" strokeWidth="3.5" strokeLinecap="round" />
        </svg>

        <div className="mt-8 flex items-center justify-center">
          <Magnetic>
            <button
              onClick={() => handleOpenApp()}
              className="group inline-flex items-center gap-3.5 rounded-full bg-gradient-to-br from-[#4328E7] via-[#4328E7] to-[#7a6bf0] py-3.5 pl-3 pr-7 font-montserrat text-[15px] font-bold text-white shadow-[0_20px_44px_-18px_rgba(67,40,231,0.55)] transition duration-300 md:hover:-translate-y-0.5"
            >
              <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full border-[2.5px] border-[#ECCD94]" />
              Create My Car Plan
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
            </button>
          </Magnetic>
        </div>
      </Reveal>
    </section>
  );
}
